import React from "react";

const TrainingCourseSuggestion = ({ title, description, selected, disabled, onClick }) => {

  const handleClick = () => {
    if (disabled) return;
    onClick && onClick({ title, description });
  }

  return (
    <div
      className={`training-course-suggestion ${selected ? "selected" : null} ${disabled ? "disabled" : null}`}
      onClick={handleClick}
    >
      <h2 className="title">{title}</h2>
      <span className="description">{description}</span>
    </div>
  );
}

export default TrainingCourseSuggestion;
